// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorReturnRequest = (client) => ({
    /**
     * `GET /vendor/return-request`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListOrderReturnRequests
     * @source packages/modules/requests/src/api/vendor/return-request/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/return-request", { method: "GET", query, headers }),
    /**
     * `GET /vendor/return-request/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetOrderReturnRequestById
     * @source packages/modules/requests/src/api/vendor/return-request/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/return-request/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/return-request/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateOrderReturnRequestById
     * @source packages/modules/requests/src/api/vendor/return-request/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/return-request/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=return-request.js.map